import "./Compliance.module.css";
import Header from "@/reusable_sections/Header";
import Compliance from "./sections/Compliance";
import Regulatory from "./sections/Regulatory";
import Regulatorycompliance from "./sections/Regulatorycompliance";
import Commitment from "./sections/Commitment";
import Footer from "@/reusable_sections/Footer";
import Compliancecertificationhero from "./sections/Compliancecertificationhero";
export default function CompliancePage() {
  return <div>
      <Header />
      <Compliancecertificationhero />
      <Compliance />
      <Regulatory />
      <Regulatorycompliance />
      <Commitment />
      <Footer />
    </div>;
}